export function isHostedVuplexEnvironment() {
    if (typeof window === "undefined") {
        return false;
    }

    return Boolean(window.vuplex) && !Boolean(window.__ANIMOTIVE_IS_LOCALHOST__);
}

export function shouldUseHostedVuplexEmbeddedRouter() {
    return isHostedVuplexEnvironment();
}

export function getEmbeddedAppInitialEntry(currentLocation = window.location) {
    if (typeof window === "undefined" || !currentLocation) {
        return "/";
    }

    const currentHash = typeof currentLocation.hash === "string" ? currentLocation.hash : "";
    if (currentHash.startsWith("#/")) {
        return currentHash.slice(1);
    }

    const pathname =
        typeof currentLocation.pathname === "string" && currentLocation.pathname.length > 0
            ? currentLocation.pathname
            : "/";
    const search = typeof currentLocation.search === "string" ? currentLocation.search : "";

    return `${pathname}${search}`;
}
